import React from 'react';
import { AlertsList } from '../components/Alerts';
import { PROMOMSG } from '../constants/rootElements';

export const renderPromoMessages = (promoMessages) => {
	PROMOMSG.render(<AlertsList messages={promoMessages}/>);
}